export const getCurrentEnv = (): string => {
  const currentEnv = document
    .querySelector('[data-environment]')
    ?.getAttribute('data-environment') || 'staging';

  return currentEnv.includes('context.environment') ? 'staging' : currentEnv;
};
